import api from 'services/api';
import configureStore from 'store/configure';

const store = configureStore({}, { api: api.create() });
export default store;
